import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
// import { compose } from 'redux';
// import { connect } from 'react-redux';
// import { withFirestore, firestoreConnect } from 'react-redux-firebase';
// import { isMobile } from 'react-device-detect';
// import NotificationCard from './NotificationCard';
// import NotificationMenu from './NotificationMenu';
// import ConfirmationDialog from './ConfirmationDialog';
// import Snackbar from './Snackbar';
// import { NOTIFICATIONS } from '../routes';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

class NotificationsMenu extends Component {
  



  render() {

    return (
      <>
        <StyledMenu
          id="customized-menu"
          anchorEl={true}
          keepMounted
          open={Boolean(true)}
          
        >
        {/*   {notifications && notifications.length ? ( */}
            <div>
              <div
                style={{
                  padding: 16,
                  maxWidth: 512,
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  style={{ fontSize: 14, fontWeight: 'bold', color: '#10587f' }}
                >
                  Tus notificaciones
                </Typography>
                <Link
                  component="button"
                  style={{
                    fontSize: '12px',
                    color: '#10587f',
                    backgroundColor: 'transparent',
                    border: 'none',
                    outline: 'none',
                    WebkitTapHighlightColor: 'transparent'
                  }}
                  onClick={this.markAllAsRead}
                >
                  Marcar todas como leídass
                </Link>
              </div>
              {/* {notifications &&
                notifications.length &&
                notifications.map(notification => {
                  return (
                    <NotificationCard
                      key={notification.id}
                      elevation={0}
                      square={true}
                      handleOpenMenu={this.handleOpenMenu({
                        id: notification.id,
                        read: notification.read,
                        featured: notification.featured,
                      })}
                      sender={notification.sender}
                      description={
                        <>
                          Te está solicitando una cotización.
                          <br />
                          Para dar seguimiento, da click en esta notificación.
                        </>
                      }
                      date={notification.date && notification.date.toDate()}
                      featured={notification.featured}
                      read={notification.read}
                      type={notification.type}
                      imageUrl={notification.imageUrl}
                      mediaWidth={62}
                      mediaHeight={62}
                      mediaMargin={8}
                      titleFontSize={16}
                      descriptionFontSize={12}
                      footerFontSize={10}
                      featuredPositionRight={10}
                      optionsButtonMargin="26px 6px 0 0"
                    />
                  ); */}
                }}
              <div style={{ padding: 16, textAlign: 'center' }}>
                <Link
                  component="button"
                  style={{
                    fontSize: '12px',
                    color: '#10587f',
                    background: 'transparent',
                    border: 'none',
                    outline: 'none',
                    WebkitTapHighlightColor: 'transparent'
                  }}
                  onClick={this.goToNotifications}
                >
                  Ver todas las notificaciones
                </Link>
              </div>
            </div>
          ) : (
            <Typography
              style={{
                padding: 16,
                fontSize: 14,
                fontWeight: 'bold',
                color: '#10587f',
              }}
            >
              No hay notificaciones
            </Typography>
          )}
        </StyledMenu>

       

      </>
    );
  }
}

export default withRouter(NotificationsMenu);
